import React from "react";
import { Card } from "../../../components/ui/Card";
import { metricTone } from "../machineAnalyticsData";
import { Link } from "react-router-dom";
import { analyticsSearch } from "../../../components/analytics/analyticsFilters";

const MetricRow = ({ label, value, suffix = "%" }) => (
  <div className="flex items-center justify-between text-sm">
    <span className="text-slate-500">{label}</span>
    <span className={`font-semibold ${suffix ? metricTone(value) : "text-slate-900"}`}>
      {value ?? "—"}
      {value != null ? suffix : ""}
    </span>
  </div>
);

const MachineCard = ({ machine, filters = {} }) => (
  <Link to={`/setting/real-time-analytics${analyticsSearch({ ...filters, machine: machine.id, line: machine.lineId || filters.line, machineType: machine.machineType || filters.machineType })}`} aria-label={`View real time analytics for ${machine.name || machine.id}`} className="rounded-xl focus:outline-none focus:ring-2 focus:ring-brand">
  <Card className="h-full bg-violet-50/60 p-4 transition-colors hover:bg-violet-100/70">
    <div className="space-y-1.5">
      <div className="flex items-center justify-between text-sm">
        <span className="text-slate-500">Total Production</span>
        <span className="font-semibold text-slate-900">{machine.totalProduction?.toLocaleString() ?? "—"}</span>
      </div>
      <MetricRow label="Productivity" value={machine.productivity} />
      <MetricRow label="Utilization" value={machine.utilization} />
      <MetricRow label="Quality" value={machine.quality} />
    </div>
    <p className="mt-3 border-t border-slate-100 pt-2.5 text-center text-sm font-semibold text-slate-700">
      {machine.name || machine.id}
    </p>
  </Card>
  </Link>
);

export default MachineCard;
